type ZoneProjectsRetrievalError = {
  wasProjectNotFound: boolean;
  hasUnExpectedError: boolean;
  message: string;
};

const zoneProjectsRetrievalError: ZoneProjectsRetrievalError = {
  wasProjectNotFound: false,
  hasUnExpectedError: false,
  message: "",
};

export type { ZoneProjectsRetrievalError };

export { zoneProjectsRetrievalError };
